module.exports = __webpack_public_path__ + "static/media/Street-view-Anarkali-1980.527066de.png";